import type { FC } from 'react'
import { ThemeProvider } from '@onhandtech/onhand-toolkit'
import type { ToolkitStore } from '@reduxjs/toolkit/dist/configureStore'
import { Provider } from 'react-redux'

import Localisation from './localisation/localisation'
import Router from './router/router'

type AppProps = {
  store: ToolkitStore
}

const App: FC<AppProps> = ({ store }) => (
  <ThemeProvider theme="odin" staticFontsUrl="/static">
    <Provider store={store}>
      <Localisation>
        <Router />
      </Localisation>
    </Provider>
  </ThemeProvider>
)

export default App
